const colors = {
    first: '#fc8d36',
    second: '#5b9e24',
    third: '#9e6524',
    forth: '#2E2E2E',
    fifth: '#1264ad',
}

export default colors
